export default {
    resource: 'log/login-audit',
    actions: ['index'],
    export(params = {}, options = {}) {
      return Vue.http.get(
        `log/login-audit/export`,
        {params, ...options}
      ).then(response => response.data)
    }
  }
  